import type React from "react"
import "./Button.css"

export type ButtonVariant = "primary" | "secondary" | "outline" | "ghost" | "icon"
export type ButtonSize = "sm" | "md" | "lg"

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  fullWidth?: boolean
  loading?: boolean
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  children?: React.ReactNode
}

export const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  fullWidth = false,
  loading = false,
  leftIcon,
  rightIcon,
  children,
  className = "",
  disabled,
  ...props
}) => {
  const classNames = [
    "btn-base",
    `btn-${variant}`,
    `btn-${size}`,
    fullWidth ? "btn-full-width" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ")

  return (
    <button
      className={classNames}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <span className="spinner spinner-sm" />}
      {!loading && leftIcon && <span className="btn-icon-left">{leftIcon}</span>}
      {children && <span className="btn-content">{children}</span>}
      {!loading && rightIcon && <span className="btn-icon-right">{rightIcon}</span>}
    </button>
  )
}